import { Fragment } from 'react';

import { Feedback } from '@playbooks/molecules/feedbacks';
import { Skeleton } from '@playbooks/molecules/skeletons';
import { cn } from '@playbooks/ui/lib/utils';
import { buildArray } from '@playbooks/utils';

import type { CollectionListProps } from './types';
import { cva, VariantProps } from 'class-variance-authority';

const searchListGridVariants = cva('grid w-full', {
	variants: { density: { default: 'gap-3', compact: 'gap-0' } },
	defaultVariants: { density: 'default' },
});

const searchListFeedbackVariants = cva('', {
	variants: { variant: { default: '', 'inset-padded': 'm-4 p-4' } },
	defaultVariants: { variant: 'default' },
});

type SearchListProps = VariantProps<typeof searchListGridVariants> &
	VariantProps<typeof searchListFeedbackVariants> &
	CollectionListProps;

const SearchList = ({
	feedbackLayout = 'search',
	skeletonLayout = 'search',
	icon = 'database',
	title = '',
	text = `We don't have any ${title?.toLowerCase()} that match your criteria.`,
	data = [],
	count = 3,
	loading = false,
	children,
	density,
	variant,
	className = '',
}: SearchListProps) => {
	// Theme
	const classNames = {
		root: cn(searchListGridVariants({ density }), className),
		feedback: cn(searchListFeedbackVariants({ variant }), className),
	};

	// Render
	return (
		<Fragment>
			{loading ? (
				<div aria-busy='true' className={classNames.root}>
					{buildArray(count).map((v, i) => (
						<div key={i}>
							<Skeleton layout={skeletonLayout} />
						</div>
					))}
				</div>
			) : data.length ? (
				<div className={classNames.root}>{children}</div>
			) : (
				<Feedback layout={feedbackLayout} icon={icon} title={title} text={text} className={classNames.feedback} />
			)}
		</Fragment>
	);
};
export { SearchList };
